import { render, staticRenderFns } from "./FormNewMail.vue?vue&type=template&id=1a7d3d5e&scoped=true"
import script from "./FormNewMail.vue?vue&type=script&lang=js"
export * from "./FormNewMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d3d5e",
  null
  
)

export default component.exports